import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const FlaskIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      htmlColor='transparent'
    >
      <path
        d="M12.7175 1.66663V9.41388L17.3529 15.3147C17.5787 15.6004 17.7194 15.9441 17.7587 16.3061C17.7981 16.6681 17.7346 17.034 17.5755 17.3616C17.4165 17.6892 17.1682 17.9653 16.8594 18.1582C16.5505 18.3511 16.1935 18.4531 15.8293 18.4523H4.44082C4.07663 18.4531 3.71962 18.3511 3.41074 18.1582C3.10186 17.9653 2.85364 17.6892 2.69455 17.3616C2.53547 17.034 2.47198 16.6681 2.51136 16.3061C2.55074 15.9441 2.6914 15.6004 2.91719 15.3147L7.55263 9.41388V1.66663M5.61582 1.66663H14.6543"
        stroke="#00598E"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
